import React from 'react';
import { actionNeededBadge, fulfillmentGroupBadge, Tone, toneClass } from '../helpers/orderDisplay';
import { FulfillmentActionNeeded } from '../../../../interfaces/order.interface';

/** The one badge/pill markup — style tweaks here reach every admin status chip. */
export const Badge: React.FC<{ tone: Tone; children: React.ReactNode; title?: string }> = ({ tone, children, title }) => (
  <span title={title} className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${toneClass[tone]}`}>
    {children}
  </span>
);

/**
 * Grouped fulfillment badge (Waiting / Needs attention / In progress / Shipped / Canceled) with
 * the precise pipeline stage as a subtitle, plus the optional action-needed chip. THE single
 * renderer — used by the order lists, the detail card header, and Order Recovery, so the same
 * status can never render two different ways.
 */
const FulfillmentStatusBadges: React.FC<{
  status?: string | null;
  actionNeeded?: FulfillmentActionNeeded | null;
}> = ({ status, actionNeeded }) => {
  const badge = fulfillmentGroupBadge(status);
  const action = actionNeededBadge(actionNeeded);
  return (
    <span className="inline-flex flex-col gap-0.5">
      <span className="flex flex-wrap gap-1 items-center">
        <Badge tone={badge.tone}>{badge.label}</Badge>
        {action && <Badge tone={action.tone}>{action.label}</Badge>}
      </span>
      {badge.stage && <span className="text-xs text-gray-500 pl-0.5">{badge.stage}</span>}
    </span>
  );
};

export default FulfillmentStatusBadges;
